export default __webpack_public_path__ + "static/media/excellent-review.e02cc578.svg";